/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Time_EveningInputs */

const en_ui_time_evening = /** @type {(inputs: Ui_Time_EveningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evening`)
};

const de_ui_time_evening = /** @type {(inputs: Ui_Time_EveningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`am Abend`)
};

/**
* | output |
* | --- |
* | "Evening" |
*
* @param {Ui_Time_EveningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_time_evening = /** @type {((inputs?: Ui_Time_EveningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Time_EveningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_time_evening(inputs)
	return de_ui_time_evening(inputs)
});